<template>
  <b-code>
    <!-- button  v-if="folders.length === 0" -->
    <b-button
      id="toggle-btn"
      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
      v-b-modal.modal-prevent-closing
      variant="outline-primary"
    >
      <feather-icon icon="FolderPlusIcon" />
      Criar Pastas
    </b-button>

    <!-- modal data -->
    <!-- <div class="mt-2">
      <div v-if="submittedNames.length === 0">

      </div>
      <b-list-group
        v-else
      >
        <b-list-group-item
          v-for="(data,index) in submittedNames"
          :key="index"
        >
          {{ data }}
        </b-list-group-item>
      </b-list-group>
    </div> -->

    <!-- modal -->
    <b-modal
      id="modal-prevent-closing"
      ref="my-modal"
      title="Nova pasta"
      ok-title="Criar Pasta"
      cancel-title="Cancelar"
      @show="resetModal"
      @hidden="resetModal"
      @ok="handleOk"
    >
      <form
        ref="form"
        @submit.stop.prevent="CriarPasta"
      >
        <b-form-group
          :state="nameState"
          label="Nome da pasta"
          label-for="name-input"
          invalid-feedback="Esse campo é obrigatório"
        >
          <b-form-input
            id="name-input"
            v-model="pastaAws.folder_name"
            :state="nameState"
            placeholder="Digite o nome da pasta"
            required
          />
        </b-form-group>
      </form>
    </b-modal>

    <template #code>
      {{ codePrevent }}
    </template>
  </b-code>
</template>

<script>

import {
  BButton, BFormGroup, BFormInput, BModal, VBModal, BCardText, BListGroup, BListGroupItem,
} from 'bootstrap-vue'
import BCardCode from '@core/components/b-card-code'
import Ripple from 'vue-ripple-directive'
import { codePrevent } from '@/views/App/Pastas/code copy'
import { FolderService } from '@/services/Folder'
import FoldersVue from './Folders.vue'

export default {
  name: 'Modal',
  components: {
    BCardCode,
    BButton,
    BFormGroup,
    BCardText,
    BFormInput,
    BListGroup,
    BListGroupItem,
    BModal,

  },
  directives: {
    'b-modal': VBModal,

    Ripple,
  },

  data() {
    return {
      VUE_APP_HOST_API_AWS_S3: process.env.VUE_APP_HOST_API_AWS_S3,
      VUE_APP_HOST_API_BACKEND: process.env.VUE_APP_HOST_API_BACKEND,
      userData: JSON.parse(localStorage.getItem('userData')),
      codePrevent,
      // folder: {
      //   folder_name: '',
      //   id_user: '',
      // },

      pastaAws: {
        folder_name: '',
      },

      nameState: null,
      folders: [],

    }
  },

  async created() {
    try {
      this.loading = true
      const response = await FolderService.getALLFolders()
      this.folders = response.data
      this.loading = false
      // console.log('folders');
      // console.log(this.folders)
    } catch (error) {
      this.errorMessage = error
      this.loading = false
    }
  },
  mounted() {
    this.listar()
  },
  methods: {
    listar() {
      FolderService.getALLFolders().then(resposta => {
        this.folders = resposta.data
      }).catch(e => {
        console.log(e)
      })
    },
    // submitCreate: async function () {

    //   },
    checkFormValidity() {
      const valid = this.$refs.form.checkValidity()
      this.name = valid
      return valid
    },
    resetModal() {
      this.pastaAws.folder_name = ''
      this.nameState = null
    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault()
      // Trigger submit handler
      this.CriarPasta()
    },
    handleSubmit() {
      fetch(`${this.VUE_APP_HOST_API_BACKEND}/folder`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: `{"folder_name":"${this.pastaAws.folder_name
        }","folder_backet_adress":"${this.Url_pasta
        }","folder_key_name":"${this.key_name
        }","id_user":"${this.userData.id}"}`,
      })
        .then(response => {
          this.$notify({
            title: 'Success',
            message: 'Pasta criada com sucesso.',
            type: 'success',
          })

          //  window.location.replace("http://localhost:8080/videos");
        })
        .catch(err => console.error(err))
      // Exit when the form isn't valid
      if (!this.checkFormValidity()) {
        return
      }

      // Push the name to submitted names
      this.folders.push(this.folder)
      // Hide the modal manually
      this.$nextTick(() => {
        this.$refs['my-modal'].toggle('#toggle-btn')
      })
    },

    CriarPasta() {
      fetch(`${this.VUE_APP_HOST_API_AWS_S3}/create?caminho=UploadFolderVideos/${this.pastaAws.folder_name}/`, {
        method: 'POST',
      })
        .then(res => res.json())
        .then(res => {
          this.Url_pasta = res.fileUrl
          this.key_name = res.file_key
          // console.log('this.Key_name')
          // console.log(this.key_name)

          if (res.status == 201) {
            this.handleSubmit()
          }
          if (res.status == 201) {
            this.listar()
          }
          // alert("Deu certo: ", res.status);
        })
        .catch(error => {
          this.$notify.error({
            title: 'Error',
            message: `Esta é uma mensagem de erro: ${error}`,
          })
        })
    },
    // handleSubmit (){
    //   fetch('http://localhost:3030/folder', {
    //     method: 'POST',
    //     headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    //     body: '{"folder_name":"' + this.folder.folder_name +
    //     '","id_user":"' + this.userData.id + '"}'

    //   })
    //   .then(response => {
    //     window.location.replace("http://localhost:8080/videos");
    //   })

    //     .catch(err => console.error(err));
    //   // Exit when the form isn't valid
    //   if (!this.checkFormValidity()) {
    //     return
    //   }

    //   // Push the name to submitted names
    //   this.folders.push(this.folder)
    //   // Hide the modal manually
    //   this.$nextTick(() => {
    //     this.$refs['my-modal'].toggle('#toggle-btn')
    //   })
    // },
  },
}
</script>
